import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { SubscriptionSummary, BillingPeriodResponse } from '../types';
import subscriptionService from '../services/subscription.service';

export const useSubscriptionSummary = () => {
    return useQuery<SubscriptionSummary>({
        queryKey: ['admin-subscriptions-summary'],
        queryFn: () => subscriptionService.getSummary()
    });
};

export const useBillingPeriods = (page: number, statusFilter: string | null) => {
    return useQuery<BillingPeriodResponse>({
        queryKey: ['admin-billing-periods', page, statusFilter],
        queryFn: () => subscriptionService.getBillingPeriods(page, statusFilter),
        placeholderData: keepPreviousData
    });
};
